/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SendTipNotificationActionData } from './SendTipNotificationActionData';
import {
    SendTipNotificationActionDataFromJSON,
    SendTipNotificationActionDataFromJSONTyped,
    SendTipNotificationActionDataToJSON,
} from './SendTipNotificationActionData';

/**
 * 
 * @export
 * @interface SendTipNotificationAction
 */
export interface SendTipNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof SendTipNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof SendTipNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SendTipNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {SendTipNotificationActionData}
     * @memberof SendTipNotificationAction
     */
    data: SendTipNotificationActionData;
}

/**
 * Check if a given object implements the SendTipNotificationAction interface.
 */
export function instanceOfSendTipNotificationAction(value: object): value is SendTipNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function SendTipNotificationActionFromJSON(json: any): SendTipNotificationAction {
    return SendTipNotificationActionFromJSONTyped(json, false);
}

export function SendTipNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendTipNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': SendTipNotificationActionDataFromJSON(json['data']),
    };
}

export function SendTipNotificationActionToJSON(value?: SendTipNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': SendTipNotificationActionDataToJSON(value.data),
    };
}

